import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import ListingCard from '../listings/ListingCard';
import Container from 'react-bootstrap/esm/Container';
import Slider from "react-slick";

import useWindowDimensions from '../hooks/useWindowDimensions';

import bgElem6 from '../../assets/images/bg-elem-6.svg';

// Load scraped listing data
import listingsData from '../../data/listings.json';

// Build card-compatible objects from scraped JSON
const buildListingData = (raw) => {
  const fileName = raw.image_filename?.replace('images/', '') || '';
  const city = raw.city_province?.split(',')[0] || '';
  return {
    imgSrc: fileName ? `/listings/${fileName}` : '',
    address: `${raw.address}, ${city}`,
    yearBuilt: raw.year_built || 'N/A',
    size: raw.sqft ? `${raw.sqft.toLocaleString()} sqft` : 'N/A',
    specs: `${raw.beds ?? '-'}/${raw.total_baths ?? '-'}`,
    price: raw.price || 'Contact',
    status: raw.status || 'Active',
    disabled: false,
  };
};

const FeaturedListings = () => {

  const { section } = useParams();
  useEffect(() => {
    if (section === 'listings') {
      const homeElem = document.getElementById('listings');
      homeElem.scrollIntoView(false);
    }

  }, [section]);

  const { width } = useWindowDimensions();
  const [ sliderSettings, setSliderSettings ] = useState({
    dots: false,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
  });

  useEffect(() => {
    if (width <= 1010) {
      setSliderSettings({
        dots: false,
        infinite: true,
        speed: 900,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
      });
    } else {
      setSliderSettings({
        dots: false,
        infinite: true,
        speed: 900,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
      });
    }
  }, [width]);

  const [listings] = useState(() => listingsData.map(buildListingData));

  return (
    <div className='bg-elem-container'>
      <img src={bgElem6} alt="graphical element" className='bg-elem bg-elem-6'></img>


    <Container id="listings" className="container-xxl">
      <div className="featured-listings">
        <h2>WHAT'S ON THE MARKET?</h2>
        <Slider {...sliderSettings} className="featured-listings-carousel">
          {
            listings.map((listing, idx) => (
              <ListingCard key={idx} data={listing} />
            ))
          }
        </Slider>
      </div>

    </Container>
    </div>
  );
};

export default FeaturedListings;
